import useIsMobile from "@/hooks/useIsMobile";
import defaultLoginMobile from "../../../assets/images/brand/rrc-wordmark.svg";
import defaultLoginDesktop from "../../../assets/images/brand/rrc-wordmark.svg";
import {useAppConfig} from "../../../store/useAppConfig.store";

export const useLoginImages = () => {
  const isMobile = useIsMobile();
  const authModalImages = useAppConfig(state => state.authModalImages);

  const loginDesktopImage = authModalImages?.loginDesktopImage || defaultLoginDesktop;
  const loginMobileImage = authModalImages?.loginMobileImage || defaultLoginMobile;
  const loginImage = isMobile ? loginMobileImage : loginDesktopImage;

  return {loginImage, loginDesktopImage, loginMobileImage};
};
